<template>
  <!-- 新增发票 -->
    <BaseDialog
      :title = "dialogTitle"
      :showVisible = "isShow"
      @close = "isShow = false"
      size = "EXTRA_LARGE"
      @confirm = "handleClickSave"
      class = "newAddPageInvoice"
      :isCancel = "!isReadonly"
      :isConfirm = "!isReadonly"
      text="保存"
    >
      <template v-slot:content>
        <div v-loading='s_loading'>
            <!-- <el-button v-for='item in buttonTab' :key='item.id' size="small" @click='hanleButtonTab(item)'
            :class='item.id === form.invoiceClassify ? "buttonActive" : ""' class='buttonList_s'>
            {{ item.name }}
          </el-button> -->
          <div class='dataForm'>
            <div class="item1">
              <div class="item_box" style="text-align:right;">
                <div v-for="(item,i) in listInfo.item1" :key="i" class="labelItem">
                    <div v-if="item.props == 'enterprieName'">
                      <div>{{invoiceClassify === 1 ? ([11,12,8,16,17,18,19,20,21,22,23,24].includes(form[item.props]) ?"供应商：": "供应商：") :( [11,12,8,16,17,18,19,20,21,22,23,24].includes(form[item.props])?"客户：":"客户：")}}</div>
                    </div>
                    <div v-else>{{item.label}}：</div>
                </div>
              </div>
              <div class="item_box">
                <div v-for="(item,i) in listInfo.item1" :key="i" class="labelItem">
                  <template v-if="item.type == 'select'">
                    <el-select v-model="form[item.props]" placeholder="请选择" size='small'  @change = "item.function" v-if = "!isReadonly " :style="{'width':item.width}">
                      <el-option v-for="childItem in item.options.filter(i=> i.id !='-1')" :key="childItem.id" :label="childItem.label" :value="childItem.id" >
                      </el-option>
                    </el-select>
                    <div v-else  class="text_view">{{ options.find(i=> i.id ==form[item.props]).label }}</div>
                  </template>
                  <template v-if="item.type == 'input'">
                      <el-input v-model='form[item.props]' size='small'  :placeholder="item.defaultText" v-if = "!isReadonly" :style="{'width':item.width}"></el-input>
                      <div v-else  class="text_view"> {{ form[item.props] }} </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="item2">
               <div class="item_box" style="text-align:right;">
                <div v-for="(item,i) in listInfo.item2" :key="i" class="labelItem">
                    <div v-if="item.props == 'taxNumber'">
                      <div>{{invoiceClassify === 1 ? "供应商纳税识别号：" : "客户纳税识别号："}}</div>
                    </div>
                    <div v-else>{{item.label}}：</div>
                </div>
              </div>
              <div class="item_box">
                <div v-for="(item,i) in listInfo.item2" :key="i" class="labelItem">
                  <template v-if="item.type == 'input'">
                      <el-input v-model='form[item.props]' size='small'  :placeholder="item.defaultText" v-if = "!isReadonly" :style="{'width':item.width}"></el-input>
                      <div v-else  class="text_view"> {{ form[item.props] }} </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="item3">
                <div class="item_box" style="text-align:right;">
                <div v-for="(item,i) in listInfo.item3" :key="i" class="labelItem">
                    <div v-show="item.props == 'invoiceCode'">
                      <div v-show = "form.invoiceType != 1 && form.invoiceType != 2 && form.invoiceType != 13 && form.invoiceType != 14">{{[12,16,17,18,19,20,21,22,23,24].includes(form.invoiceType)?"发票代码：":"发票代码："}}</div>
                    </div>
                    <div v-show="item.props != 'invoiceCode'">{{item.label}}：</div>

                </div>
              </div>
              <div class="item_box">
                <div v-for="(item,i) in listInfo.item3" :key="i" class="labelItem">
                  <template v-if="item.type == 'date'">
                     <el-date-picker size='small'  v-model="form[item.props]" type="date" :style="{'width':item.width}"
                      :picker-options='pickerBeginDate' value-format="yyyy-MM-dd" :placeholder="item.defaultText" v-if = "!isReadonly">
                    </el-date-picker>
                   <div v-else  class="text_view">{{ form[item.props] }}</div>
                  </template>
                  <template v-if="item.type == 'input'">
                      <div v-show="item.props == 'invoiceCode'">
                        <el-input v-model='form[item.props]' size='small'  :placeholder="item.defaultText" v-if = "form.invoiceType != 1 && form.invoiceType != 2 && form.invoiceType != 13 && form.invoiceType != 14&&!isReadonly" :style="{'width':item.width,'min-height':'32px'}"></el-input>
                        <div v-else  class="text_view"> {{ form[item.props] }} </div>
                      </div>
                      <div v-show="item.props != 'invoiceCode'">
                        <el-input v-model='form[item.props]' size='small'  :placeholder="item.defaultText" v-if = "!isReadonly" :style="{'width':item.width}"></el-input>
                        <div v-else  class="text_view"> {{ form[item.props] }} </div>
                      </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class='chioceChange' v-show = "form.invoiceType != 11 && form.invoiceType != 8">
            <el-checkbox v-model='form.havaItem' :disabled = "isReadonly">是否录入发票明细</el-checkbox>
          </div>
          <transition name="leave_right">
            <el-row class='onlyTotal' v-if='!form.havaItem || form.invoiceType == 11 || form.invoiceType == 8'
              style="text-align: left;font-weight: 600;color: #333333;padding: 30px 30px 12px;">
              <el-col :span='8'>
                <span style='margin-right: 10px;'>*合计金额</span>
                <el-input size='small' style='width: 70%;' placeholder='请输入合计金额' @blur='handleInputC' v-if = "!isReadonly"
                  v-model='form.totalAmount'></el-input>
                  <span v-else>{{form.totalAmount  }}</span>
              </el-col>
              <el-col :span='8'>
                <span style='margin-right: 10px;'>*合计税额</span>
                <el-input size='small' style='width: 70%;' placeholder='请输入合计税额' @blur='handleInputC' v-if = "!isReadonly"
                  v-model='form.totalTax'></el-input>
                  <span v-else>{{form.totalTax  }}</span>
              </el-col>
              <el-col :span='8'>
                <span style='margin-right: 10px;'>合计价税</span>
                <el-input size='small' style='width: 70%;' placeholder='自动计算' disabled v-if = "!isReadonly"
                  v-model='form.totalAmountAndTax'></el-input>
                  <span v-else>{{form.totalAmountAndTax  }}</span>
              </el-col>
            </el-row>
          </transition>
          <transition name="leave_left">
            <div class='Detailed' v-if='form.havaItem && form.invoiceType != 11 && form.invoiceType != 8'>
              <div style="display:flex;align-items:center;column-gap:16px;margin-bottom:12px;">
                <div class="viewTab_box">
                  <template v-for="item in btnList" >
                    <div class="viewTab_btn" :key="item.id" :class="{'activeBtn':tabId == item.id}" @click="changeViewFn(0,item.id,item.label)" v-if="item.show">
                      <div class="btn_text">{{item.label}}</div>
                    </div>
                  </template>
                </div>
                <div style="color:#FF6010" v-show="!isReadonly && viewTitle">按照【{{viewTitle}}】生成凭证</div>
                <!-- <div style="text-align: left;font-weight: 600;color: #333333;margin-bottom: 12px;">
                  {{viewTitle}}
                </div> -->
                <!-- <div style="display:flex;column-gap:10px;">
                  <template v-for="item in btnList" >
                      <div :key="item.id" v-show="item.show" @click="changeViewFn(0,item.title,item.id)" style="cursor:pointer;color:#269D7B;">{{item.label}}</div>
                  </template>

                </div> -->
              </div>
            
              <!-- 表格 -->
              <public-table :table="tableData" v-show="tabId === 2">
                <template v-for="(item, index) in tableData.config" :slot='item.value' slot-scope='props'
                  v-if='item.show === "template"'>
                  <div v-if='item.value === "taxClassify" && !props.scope.row.isTotal'
                    @click.stop='isInputShow(props.scope.row, item.value)' style='height: 29px;'>
                    <span v-if='!props.scope.row.inputShowControl[item.value]'>
                      {{ getSelectName(props.scope.row[item.value]) }}
                    </span>
                    <el-select v-model="props.scope.row.taxClassify" placeholder="请选择" size='small' style='width: 100%;'
                      clearable v-else>
                      <el-option v-for="item in objectList" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>

                  <div class='hiddenRow' v-else-if='item.value === "operation" && !props.scope.row.isTotal && !isReadonly'>
                    <span @click='handleOperationTable("+", props.scope.row)'>
                      <i class="el-icon-plus" title="新增一条" style="margin-right: 15px;"></i>

                    </span>
                    <span @click='handleOperationTable("-", props.scope.row)'>
                      <i class="el-icon-delete" title="删除当前" style="margin-right: 15px;"></i>
                    </span>
                  </div>
                  <div v-else @click.stop='isInputShow(props.scope.row, item.value)' class='editContainer'>
                    <span
                      v-if='!props.scope.row.inputShowControl[item.value]'>{{ formatValue(props.scope.row[item.value], item.value, props.scope.row) }}</span>
                    <el-input size='small' v-model='props.scope.row[item.value]' v-else placeholder='请输入' :ref='item.value'
                      @blur='handleTotal(item.value, props.scope.row)' @focus='isInputFocus(props.scope.row, item.value)'
                      @keyup.enter.native='handleEnter(props.scope.row, item.value)'>
                      <template slot="append" v-if='item.value === "taxRate"'>%</template>

                    </el-input>
                  </div>
                </template>
              </public-table>
              <!-- 修改凭证 -->
             <div v-show="tabId !== 2" class="viewVoucher">
              <voucherTemplate  :row="req_nowRow" ref="voucherTemplate"
                 v-if="isShow"
                 :hideBtn="true"
                 :hideKeyDownTask="true">
                 <template #showErrorMessage>
                  <div v-show="showErrorMsg" class="showErrorTip">
                    <div class="box">
                      <div class="showErrorMsg">
                      </div>
                      <span v-show="tabId == 3">请先在<span class="fontC">【设置】-【科目】</span>里创建<span class="fontC">“{{errorKeyWrod}}”</span>
                      <span v-show="showErrorMsg && showErrorMsg.indexOf('未创建')>-1">的下级科目后再尝试。</span>
                     </span>
                      <span v-show="tabId == 1">请先在<span class="fontC">【模板设置】</span>里调整<span class="fontC">“{{errorKeyWrod}}”</span>的模板内容后再尝试。</span>
                      <div class="setting" @click="jumpSetting">去设置<i class="el-icon-right"></i></div>
                  </div>  
                 </div>
                 </template>
              </voucherTemplate>
            </div>
                </div>
          </transition>
          <el-row class='Remarks'>
                <el-col :span='1'>备注：</el-col>
                <el-col :span='23'>
                  <el-input v-model='form.remarks' size='small' placeholder='请输入备注' maxlength="200"
                      :autosize="{ minRows: 4, maxRows: 6}"
                      show-word-limit
                    style='width: 100%;padding-left: 5px;' type="textarea" v-if = "!isReadonly">
                  </el-input>
                  <span v-else>{{ form.remarks }}</span>
                </el-col>

              </el-row>
          <el-row class='footer' style="display:flex;align-items:center;">
            <template v-if="nowEditRow.id">
            <span >推荐模板凭证：</span>
            <template v-if="isReadonly">
              <div v-for="(temp,tempi) in predictedTemplateInfo" :key="tempi" style="color:#333333;margin-right:10px;" >
                {{temp.creditDirection}}：{{temp.subjectName}}
              </div>
            </template>
            <div style="display:flex;width:240px;overflow:hidden;" v-else class="disabledPredicted">
              <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
              <div slot="content">
                  <div v-for="(temp,tempi) in nowEditRow.predictedTemplateInfo" :key="tempi"  >
                  {{temp.creditDirection}}：{{temp.subjectName}}
              </div>
              </div>
              <div v-for="(temp,tempi) in nowEditRow.predictedTemplateInfo" :key="tempi" style="color:#999999;margin-right:10px;" >
                  {{temp.creditDirection}}：{{temp.subjectName}}
              </div>
               </el-tooltip>
            </div>
            </template>
            <span style="margin-left: 10px;">套用模板凭证：</span>
            <el-select v-model="form.invoiceVoucherTemplateId" placeholder="请选择" size='small'
              style='width: 240px;margin-right: 10px;' v-if = "!isReadonly" @change="changeViewFn(1)">
              <el-option v-for="item in voucherTemplateList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <span v-else>{{ voucherTemplateList.find(i=>i.id==form.invoiceVoucherTemplateId )?voucherTemplateList.find(i=>i.id==form.invoiceVoucherTemplateId ).name:"-" }}</span>
            <el-button type='text' @click='handleJump' v-if = "!isReadonly">模板管理</el-button>
          </el-row>
          <el-row v-show="detailList && detailList.length > 1">
            <div class="pageInfo">
              <div class="prev" @click="changePage('prev')">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div>{{detailList.findIndex(x=>x.id == currentId) + 1}}/{{detailList.length}}</div>
              <div class="next" @click="changePage('next')">
                 <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-row>
          <!-- <div style='text-align: center;'>
            <el-button size='small' style='width: 122px;background: #9B9B9B;color: #fff;' @click='quxiao'>取消</el-button>
            <el-button size='small' style='width: 122px;background: #269D7B;color: #fff;' v-if = "!isReadonly"
              @click='handleClickSave'>保存</el-button>
          </div> -->
        </div>
        <!-- <div v-show="buttonKey === 'show'" class="viewVoucher">
          修改凭证
          <voucherTemplate  :row="req_nowRow" @on-close-dialog="cancel($event, 'edit')"
            @on-success-submit="$emit('refreshTable')" @refreshTable="$emit('refreshTable')"  v-if="buttonKey === 'show'">
          </voucherTemplate>
        </div> -->
      </template>
    </BaseDialog>
</template>
<script>
import publicTable from '@/components/publicTable'
import {editInvolvePreview} from '@/api'
import { currencys } from '@/assets/utils/currencyFormat'
import { invoiceTypes } from "@/assets/js/library"
import BaseDialog from '@/components/dialog/BaseDialog.vue';
import voucherTemplate from '@/components/table/voucherTemplate'
export default {
  props: {
    newAddPageInvoiceShow: Boolean,
    nowEditRow: Object,
    invoiceClassify: Number,
    voucherTemplateList: Array,
  },
  components: { 
    voucherTemplate,
    publicTable,
    BaseDialog
  },
  data() {
    return {
      errorKeyWrod:"",
      showErrorMsg:false,
      listInfo:{
        item1:[
          {
            label:'发票类型',
            props:'invoiceType',
            type:'select',
            function:this.handleInvoiceChange,
            options:invoiceTypes,
            width:'274px'
          },
          {
            label:'客户',
            props:'enterprieName',
            type:'input',
            defaultText:'供应商/客户',
            width:'274px'
          }
        ],
        item2:[
          {
            label:'发票号码',
            props:'invoiceNumber',
            type:'input',
            defaultText:"请输入发票号码",
            width:'241px'
          },
          {
            label:'客户纳税识别号',
            props:'taxNumber',
            type:'input',
            width:"241px",
            defaultText:'供应商/客户纳税识别号',
          }
        ],
        item3:[
          {
            label:'发票日期',
            props:'billingDate',
            type:'date',
            defaultText:'选择日期',
            width:'297px'
          },
          {
            label:'发票代码',
            props:'invoiceCode',
            type:'input',
            width:"297px",
            defaultText:'请输入发票代码',
          }
        ]
      },
      lastTemplateId:"",
      eidtPreviewInfo:{},
      viewTitle:"",
      isLook:false,
      tabId:2,
      tuijianInfo:[],
      taoyongInfo:[],
      btnList:[{
        title:"发票明细",
        label:"发票明细",
        show:true,
        id:2,
      },
      {
        title:"推荐凭证",
        label:"推荐凭证",
        show:true,
        id:3
      },{
        title:"套用凭证",
        label:"套用凭证",
        show:true,
        id:1
      },],
      req_nowRow:{},
      predictedTemplateInfo:[],
      currentId:'',
      detailList:[],
      pickerBeginDate: {
        disabledDate: (time) => {
          let nowDate = new Date().getTime();
          if (nowDate) {
            return time.getTime() > nowDate;
          }
        }
      },
      s_loading: false,
      //voucherTemplateList:[],     // 模板下拉框
      form: {
        totalAmount: "",
        // fullElectricInvoice: true,
        totalTax: "",
        totalAmountAndTax: "",
        havaItem: true,      // 是否有分录
        invoiceSource: 3,   //来源
        id: "",
        invoiceClassify: 2, // 发票种类
        invoiceType: "2",   // 发票类型
        invoiceCode: "",  //发票代码
        invoiceNumber: "", //发票号码
        billingDate: "",  // 发票日期
        enterprieName: "",  // 供应商、客户
        taxNumber: "",     // 供应商/客户纳税识别号
        remarks: "",  // 备注
        invoiceVoucherTemplateId: "", // 套用模板凭证
        invoiceItemsVoList: [],  // 明细表
      },
      objectList: [],       // 征税项目
      tableData: {
        Maxheight:'550px',
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,				// 是否显示加载动画
        hasSelect: false,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        config: [{
          label: '',
          value: 'operation',
          show: 'template',
          width: 30,
        }, {
          label: '行号',
          value: 'rowNumber',
          show: 'normal',
          width: 60
        }, {
          label: '*商品名称',
          value: 'commodityName',
          show: 'template'
        }, {
          label: '规则型号',
          value: 'specificationModel',
          show: 'template'
        }, {
          label: '单位',
          value: 'unit',
          show: 'template'
        }, {
          label: '数量',
          value: 'quantity',
          show: 'template',
        }, {
          label: '单价',
          value: 'unitPrice',
          show: 'template',
        }, {
          label: '*金额',
          value: 'amount',
          show: 'template'
        }, {
          label: '*税率',
          value: 'taxRate',
          show: 'template',
        }, {
          label: '*税额',
          value: 'tax',
          show: 'template',
        }, {
          label: '税收项目',
          value: 'taxClassify',
          show: 'template',
        }],
        data: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          count: 10
        },
        center: {
          textAlign: 'center',
          padding: '6px 0'
        },
        toggleRowSelection: this.toggleRowSelection,		// 自定义全选方法
        headerCellStyle: this.headerCellStyle,		// 自定义表头样式
        cellStyle: this.cellStyle,		// 自定义表格样式
        arraySpanMethod: this.arraySpanMethods,			// 自定义合并行
      },
      options: invoiceTypes,

      rules: {
        type: [{ required: true, message: '发票类型不能为空！' }]
      },      // 规则

      rowData: {          // 新增单元行
        rowNumber: 1,
        commodityName: "",
        specificationModel: "",
        unit: "",
        quantity: "",
        unitPrice: "",
        amount: "",
        taxRate: "",
        tax: "",
        taxClassify: "",
        id: "",
        inputShowControl: {
          commodityName: false,
          specificationModel: false,
          unit: false,
          quantity: false,
          unitPrice: false,
          amount: false,
          taxRate: false,
          tax: false,
          taxClassify: false
        }
      },
      rowTotal: [{        // 新增合计行
        commodityName: "合计",
        rowNumber: "",
        specificationModel: 0,
        unit: "",
        quantity: '',
        unitPrice: "",
        amount: "",
        taxRate: "",
        tax: "",
        taxClassify: "",
        id: "",
        isTotal: true,
        rows: 5,
        inputShowControl: {
          commodityName: false,
          specificationModel: false,
          unit: false,
          quantity: false,
          unitPrice: false,
          amount: false,
          taxRate: false,
          tax: false,
          taxClassify: false
        }
      }, {
        commodityName: "合计价税",
        rowNumber: "",
        specificationModel: 0,
        unit: "",
        quantity: "",
        unitPrice: "",
        amount: "",
        taxRate: "",
        tax: "",
        taxClassify: "",
        id: "",
        rows: 5,
        isTotal: true,
        inputShowControl: {
          commodityName: false,
          specificationModel: false,
          unit: false,
          quantity: false,
          unitPrice: false,
          amount: false,
          taxRate: false,
          tax: false,
          taxClassify: false
        }
      }]
    }
  },
  created() {
    this.getObjectList();

  },
  mounted() {
  },
  computed: {
    // 显示弹窗
    isShow: {
      get() {
        return this.newAddPageInvoiceShow;
      },
      set(val) {
        this.$emit('update:newAddPageInvoiceShow', val);
      }
    },
    isReadonly() {
      return !!this.nowEditRow.vocherChiefWordNumber
    },
    dialogTitle() {
      let tail = this.invoiceClassify === 1 ? "进项发票":"销项发票"
      let startText = this.isReadonly?"":this.nowEditRow && this.nowEditRow.id?'编辑': '新增'
      return (startText + tail)
    }
  },
  methods: {
    jumpSetting(){
      if(this.tabId == 3){
       this.isShow = false
       this.$nextTick(()=>{
        this.$router.push({
          path:"/subjectList",
          query:{
            noReq:true
          }
        })
       })
      }else if(this.tabId == 1) {
        this.$emit('openTask')
      }
    }, 
    getViewInfo(){
       console.log('查询编辑装凭证.........')
        let totalAmount,totalTax,totalAmountAndTax
        this.tableData.data.forEach(x=>{
          if(x.commodityName == '合计价税'){
            totalAmountAndTax = x.specificationModel
          }else if(x.commodityName == '合计'){
            totalTax = x.quantity
            totalAmount = x.specificationModel
          }
        })
        const params = {
          ids:1,
          type:this.typeId, //1 套用模板 //3 推荐模板
          combinationMode:1,
          invoiceClassify:this.form.invoiceClassify,
          id:this.nowEditRow.id,
          invoiceType:this.form.invoiceType,
          invoiceCode:this.form.invoiceCode,
          invoiceNumber:this.form.invoiceNumber,
          enterprieName:this.form.enterprieName,
          invoiceVoucherTemplateId:this.form.invoiceVoucherTemplateId,
          billingDate:this.form.billingDate,
          totalAmount,
          totalTax,
          totalAmountAndTax,
          predictedInvoiceVoucherSubjectDetails:this.nowEditRow.predictedInvoiceVoucherSubjectDetails
        }
        editInvolvePreview(params).then(res=>{
          if(res.data.code ==='1'){
          
            console.log(res.data.data)
            this.eidtPreviewInfo = res.data.data
            this.req_nowRow = res.data.data[0].voucherChiefVo
            if(this.tabId == 1) {
              this.taoyongInfo = res.data.data
            }
            if(this.tabId == 3){
              this.tuijianInfo = res.data.data
            }
            this.isLook = true
            console.log(this.req_nowRow)
          } else if(res.data.code === '20'){
            this.showErrorMsg = res.data.msg
            let result = res.data.msg.match(/'([^']+)'/)[1]
            this.errorKeyWrod = result
            const str = res.data.msg.replace(result,`<span style='color:#FF6010'>${result}</span>`)
            const dom = document.querySelector('.showErrorMsg')
            let divs = `
              ${str}
            `
            // console.log(dom,result,str)
            dom.innerHTML = divs
            this.req_nowRow = {}
          } else {
            this.req_nowRow = {}
            // this.showErrorMsg = res.data.msg
            // this.eidtPreviewInfo = {}
            // this.isLook = false
            // this.$forceUpdate()
            console.log(this.req_nowRow)
          }
        })
    },
    changeViewFn(isChange,id,title){
      this.showErrorMsg = false
      // if(id == this.tabId) return
      if(id !== 2){
        this.viewTitle = title || this.viewTitle
        this.lastTemplateId = id || this.lastTemplateId
      }
      if(this.tabId == 1 && this.taoyongInfo.length && this.isLook){ //保存修改的套用模板数据
          this.taoyongInfo = this.getTemplateInfo()
      }else if(this.tabId == 3 && this.tuijianInfo.length && this.isLook){  //保存修改的推荐模板数据
          this.tuijianInfo = this.getTemplateInfo()
      }
      this.typeId = id||this.typeId
      this.tabId = id|| this.tabId
      if(this.tabId !== 2 && isChange != 1){
        if(this.tabId == 1 && this.taoyongInfo.length && this.isLook){   //如果有缓存数据则赋值 没有则请求数据
          this.req_nowRow = this.taoyongInfo[0].voucherChiefVo
        }else if(this.tabId == 3 && this.tuijianInfo.length && this.isLook){
          this.req_nowRow = this.tuijianInfo[0].voucherChiefVo
        }else {
          if(this.isReadonly ) return  
          this.getViewInfo()
        }
      }else {
         if(this.isReadonly || id == 2 ) return  
         this.getViewInfo()
      }
    },
    // 修改关闭
    cancel(e, type) {
      this.XG_voucherShow = false;
      this.openButton_s = false;
    },
    changePage(type){
      const findIndex = this.detailList.findIndex(x=>x.id == this.currentId)
      if((type == 'prev' && findIndex == 0) || (type == 'next' && (findIndex + 1 == this.detailList.length))){
        return
      }
      if(type == 'prev'){
        this.currentId = this.detailList[findIndex - 1].id
      }
      if(type == 'next'){
        this.currentId = this.detailList[findIndex + 1].id
      }
      const findItem =  this.detailList.find(x=>x.id == this.currentId)
      this.tableData.data = findItem.invoiceItemsVoList.concat(JSON.parse(JSON.stringify(this.rowTotal)));
      this.predictedTemplateInfo = findItem.predictedTemplateInfo
      this.form = Object.assign(this.form,findItem)
    },
    // 发票类型改变
    handleInvoiceChange(e) {
      this.form.havaItem =( e != 8 && e!=11);
    },
    // 下拉框名字显示
    getSelectName(val) {
      let value = "";
      if (!this.objectList.length) {
        return "";
      } else {
        this.objectList.forEach(i => {
          if (i.value == val) {
            value = i.label;
          }
        })
      }
      return value
    },
    // enter时间到了
    handleEnter(row, value) {
      const _ = this;
      if (value === "commodityName") {
        _.$refs['specificationModel'][0].focus();
      } else if (value === "specificationModel") {
        _.$refs['unit'][0].focus();
      } else if (value === "unit") {
        _.$refs['quantity'][0].focus();
      }
      else if (value === "quantity") {
        _.$refs['unitPrice'][0].focus();
      }
      else if (value === "unitPrice") {
        _.$refs['amount'][0].focus();
      }
      else if (value === "amount") {
        _.$refs['taxRate'][0].focus();
      } else if (value === "taxRate") {
        _.$refs['tax'][0].focus();
      } else if (value === "tax") {

        _.handleBodyClick();
        if (row.rowNumber === _.tableData.data.length - 2) {
          _.handleOperationTable("+", row)
        }
        let data = _.tableData.data[row.rowNumber].inputShowControl;
        for (let i in data) {
          data[i] = true;
        }
        setTimeout(() => {
          _.$refs['commodityName'][0].focus();
        }, 0)
      }
    },
    // 合计计算
    handleInputC() {
      if (isNaN(this.form.totalAmount) && isNaN(this.form.totalTax)) {
        return;
      }
      if (isNaN(this.form.totalAmount)) {
        this.form.totalAmount = "";
      }
      if (isNaN(this.form.totalTax)) {
        this.form.totalTax = "";
      }
      this.form.totalAmountAndTax = Number(this.form.totalAmount) + Number(this.form.totalTax)
    },
    // 打开模板管理
    handleJump() {
      this.$emit('openTempelete', true);
      this.isShow = false;
    },
    // 格式化数据
    formatValue(val, type, row) {
      if (row && (row.commodityName === "合计" || row.commodityName === '合计价税')) {
        if (!Number(val)) {
          if (val === "合计") {
            return "合计"
          } else if (val === "合计价税") {
            return "合计价税"
          } else {
            return ""
          }
        } else {
          return currencys(val)
        }
      }
      if (!val) {
        return "";
      } else if (type === "taxRate") {
        return Number(val) ? (Number(val).toFixed(0) + "%") : ""
      } else if (type === 'commodityName' || type === 'specificationModel' || type === 'unit') {
        return val;
      } else if (Number(val)) {
        if (type === "quantity") {
          let vals = val.toString().split(".");
          if (vals.length > 1 && vals[1].length > 9) {
            vals[1] = vals[1].substring(0, 9);
          }
          return Number(vals.join("."))
        } else {
          return currencys(val)
        }
      }
    },
    // 取消
    quxiao() {
      this.isShow = false;
    },
    // 点击保存
    handleClickSave() {
      if (this.form.havaItem) {
        this.form.invoiceItemsVoList = this.tableData.data.slice(0, -2);
        let y = this.form.invoiceItemsVoList.every(i => {
          return i.tax < 1000000000 && i.quantity < 1000000000 && i.unitPrice < 1000000000 && i.amount < 1000000000
        })
        if (!y) {
          return this.$message.warning("检测到列表数字超过上限！")
        }
      } else {
        this.form.invoiceItemsVoList = [];
      }

      if (this.form.invoiceItemsVoList.length) {
        let dataBoolean = this.form.invoiceItemsVoList.every(i => {
          return 0 <= Number(i.taxRate) && Number(i.taxRate) <= 100
        })
        if (!dataBoolean) {
          return this.$message.warning('税率只能是0%-100%');
        }
      }
      if(!this.form.havaItem || this.form.invoiceType == 11 || this.form.invoiceType == 8) {
        if(!this.form.totalTax) {
          return this.$message.error('合计税额不能为空');
        }
        if(!this.form.totalAmountAndTax) {
          return this.$message.error('合计金额不能为空');
        }
      }
      this.$http.post('invoiceController/selfSave', this.form).then(res => {
        if (res && res.data.code == 1) {
          if(this.isLook){
            let params
            if(this.lastTemplateId == 1){
              params = this.taoyongInfo
            }else if(this.lastTemplateId == 3){
              params = this.tuijianInfo
            }
            this.$http.post('PreVoucherChiefController/savaVoucherChiefV2' , params,{json:true}).then(res=>{
            if(res&&res.data.code==1){
              this.$message.success("保存成功！")
              this.isShow = false;
              this.$emit('successBack', true)
            }
				})
          }else {
            this.$message.success("保存成功！")
            this.isShow = false;
            this.$emit('successBack', true)
          }
        }
      })
    },
    getTemplateInfo(){
          const {voucher,voucherAddendumVoList} = this.$refs.voucherTemplate.$refs.voucherContent
          let params = Object.assign(JSON.parse(JSON.stringify(this.req_nowRow)),voucher)
          params.voucherAddendumVoList = voucherAddendumVoList
          let totalAmount,totalTax
          this.tableData.data.forEach(x=>{
             if(x.commodityName == '合计'){
              totalTax = x.quantity
              totalAmount = x.specificationModel
            }
          })
          let reqInfo = [{
            billList:[{
              displayContent:this.form.enterprieName,
              dateStr:this.form.billingDate,
              id:this.nowEditRow.id,
              invoiceNumber:this.form.invoiceNumber,
              totalAmount,
              totalTax
            }],
            type:this.eidtPreviewInfo[0].type,
            voucherChiefVo:params
          }]
          return reqInfo
    },
    //超级计算
    handleTotal(val, row) {
      if (val !== "commodityName" && val !== "specificationModel" && val !== "unit") {
        if (row[val] !== "-" && isNaN(Number(row[val]))) {
          row[val] = '';
        }
        let data1 = this.tableData.data.find(i => { return i.isTotal && i.commodityName === "合计" });
        let data2 = this.tableData.data.find(i => { return i.isTotal && i.commodityName === "合计价税" });
        data1.specificationModel = 0;
        data1.quantity = 0;
        data2.specificationModel = 0;
        this.tableData.data.forEach(i => {
          if (!i.isTotal) {
            i.taxRateS = i.taxRate ? (i.taxRate / 100).toFixed(2) : 0;
            if (val === "taxRate") {
              i.tax = i.taxRateS * i.amount;
            } else if (val === "tax" || val === "amount") {
              if (val === "amount") {
                i.tax = i.amount * i.taxRateS;
                i.unitPrice = (i.amount / i.quantity === Infinity || i.amount / i.quantity === -Infinity) ? 0 : i.amount / i.quantity;
                i.unitPrice = Number(i.unitPrice) ? i.unitPrice : "";
              } else {
                //i.tax =  Number(i.tax).toFixed(2)
                i.taxRate = (i.tax / i.amount === Infinity || i.tax / i.amount === -Infinity) ? 0 : (i.tax / i.amount * 100).toFixed(2);
                i.taxRate = Number(i.taxRate) ? i.taxRate : "";
              }

            } else if (val === "quantity" || val === "unitPrice") {
              //i.unitPrice = Number(i.unitPrice).toFixed(2)
              //i.quantity = Number(i.quantity).toFixed(9)
              i.amount = i.quantity * i.unitPrice;
              i.tax = i.taxRateS * i.amount;
            }
            data1.specificationModel += Number(i.amount);
            data1.quantity += Number(i.tax);
            data2.specificationModel = data1.specificationModel + data1.quantity;

          }
        })
      }
    },
    // 合计合并
    arraySpanMethods({ row, column, rowIndex, columnIndex }) {
      if (row.isTotal) {
        if (row.commodityName === "合计") {
          if (columnIndex === 2) {
            return [1, 5];
          }
        } else if (row.commodityName === "合计价税") {
          if (columnIndex === 2) {
            return [1, 5]
          } else if (columnIndex === 3) {
            return [1, 3]
          }
        }

      }
    },

    // 得到焦点
    isInputFocus(row, key) {
      this.$refs[key][0].select();
      // for(let i in row.inputShowControl) {
      // 	row.inputShowControl[i] = true;
      // }
    },
    // 表格编辑可见
    isInputShow(row, key) {
      if(this.isReadonly) return;
      this.handleBodyClick();
      if (row.isTotal) { return }

      for (let i in row.inputShowControl) {
        row.inputShowControl[i] = true;
      }
      // row.inputShowControl[key] = true;
      this.$nextTick(() => {
        //this.$refs[key][0].focus();
        //this.$refs[key][0].select();
      })
    },
    // 新增删除表格
    handleOperationTable(type, row) {
      if (type === "+") {
        let data = JSON.parse(JSON.stringify(this.rowData))
        if (row.rowNumber === this.tableData.data.length - 2) {
          data.rowNumber = row.rowNumber + 1;
          this.tableData.data.splice(this.tableData.data.length - 2, 0, data)
        } else {
          this.tableData.data.splice(row.rowNumber - 1, 0, data)
          this.tableData.data.map((i, index) => {
            if (i.isTotal) {
              i.rowNumber = "";
            } else {
              i.rowNumber = index + 1;
            }
            return i;
          })
        }

      } else {
        if (this.tableData.data.length === 3) {
          return this.$message.warning('表格必须保留一条数据!')
        }
        this.tableData.data.splice(row.rowNumber - 1, 1);
        this.tableData.data.map((i, index) => {
          if (i.isTotal) {
            i.rowNumber = "";
          } else {
            i.rowNumber = index + 1;
          }
          return i;
        })
      }
    },
    // 表头单元格样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "headerCellStyle"
      }

    },
    // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "cellStyle"
      }
    },
    // 获取征税项目
    getObjectList() {
      this.$http.post('sys/dict/list', { type: 'invoice_taxClassify' }).then(res => {
        if (res && res.data.code == 1) {
          this.objectList = res.data.data;
        }
      })
    },
    handleBodyClick() {
      if (this.tableData && this.tableData.data.length) {
        this.tableData.data.forEach(i => {
          for (let j in i.inputShowControl) {
            i.inputShowControl[j] = false;
          }
        })
      }
    },
    handleSwitchChange() {
      this.form = Object.assign(this.form, {
        invoiceCode: "",  //发票代码
        invoiceNumber: "", //发票号码
      })
    }
  },
  watch: {
    newAddPageInvoiceShow(val) {
      this.isLook = false
      this.showErrorMsg = false
      this.tabId = 2
      this.viewTitle = ''
      this.errorKeyWrod = ''
      this.lastTemplateId = ''
      this.tuijianInfo = []
      this.taoyongInfo = []
      if (val) {
      console.log(this.nowEditRow,'当前的数据')
        this.btnList = this.btnList.map(x=>{
          if(x.id == 1 && !this.nowEditRow.invoiceVoucherTemplateId){
            x.show = false
          }else if(x.id == 3 && !this.nowEditRow.predictedInvoiceVoucherSubjectDetails) {
            x.show = false
          }else {
            x.show = true
          }
          return x
        })
        document.body.addEventListener('click', this.handleBodyClick)
        if (this.invoiceClassify == 2) {
          this.form.invoiceVoucherTemplateId = this.voucherTemplateList[0] ? this.voucherTemplateList[0].id : "";
        } else {
          this.form.invoiceVoucherTemplateId = this.voucherTemplateList[1] ? this.voucherTemplateList[1].id : "";
        }
        if (this.nowEditRow && this.nowEditRow.id) {
          this.form = Object.assign(this.form, {
            invoiceClassify: this.nowEditRow.invoiceClassify, // 发票种类
            invoiceType: this.nowEditRow.invoiceType.toString(),   // 发票类型
            invoiceCode: this.nowEditRow.invoiceCode,  //发票代码
            invoiceNumber: this.nowEditRow.invoiceNumber, //发票号码
            billingDate: this.nowEditRow.billingDate,  // 发票日期
            enterprieName: this.nowEditRow.enterprieName,  // 供应商、客户
            taxNumber: this.nowEditRow.taxNumber,     // 供应商/客户纳税识别号
            remarks: this.nowEditRow.remarks,  // 备注
            invoiceVoucherTemplateId: this.nowEditRow.invoiceVoucherTemplateId, // 套用模板凭证
            id: this.nowEditRow.id,
            invoiceSource: this.nowEditRow.invoiceSource,
            totalAmount: this.nowEditRow.totalAmount,
            totalAmountAndTax: this.nowEditRow.totalAmountAndTax,
            totalTax: this.nowEditRow.totalTax,
            havaItem: this.nowEditRow.havaItem,
            // fullElectricInvoice: this.nowEditRow.fullElectricInvoice,

          })
          if (this.nowEditRow.havaItem) {
            this.s_loading = true;
            this.$http.post('invoiceController/findInvoiceDetail',{id:this.nowEditRow.id}).then(res => {
              this.s_loading = false;
              if (res && res.data.code == 1) {
                let list = res.data.data
                if(list && list.length){
                  list = list.map((i, index) => {
                  if(i.invoiceItemsVoList && i.invoiceItemsVoList.length){
                    i.invoiceItemsVoList = i.invoiceItemsVoList.map((x,k)=>{
                      x.rowNumber = k + 1;
                      x.inputShowControl = {
                        commodityName: false,
                        specificationModel: false,
                        unit: false,
                        quantity: false,
                        unitPrice: false,
                        amount: false,
                        taxRate: false,
                        tax: false,
                      }
                      return x
                    })
                  }
                  return i
                })
                }
                this.detailList = list
                this.currentId = this.detailList[0].id
                console.log(this.detailList)
                this.predictedTemplateInfo = this.detailList[0].predictedTemplateInfo
                this.tableData.data = this.detailList[0].invoiceItemsVoList.concat(JSON.parse(JSON.stringify(this.rowTotal)));
                let data = JSON.parse(JSON.stringify(this.detailList[0]))
                data.id = data.voucherChiefId;
                this.req_nowRow = data;
                this.handleTotal("tax", this.nowEditRow);
              }
            })
          } else {
            this.tableData.data.push(JSON.parse(JSON.stringify(this.rowData)));
            this.tableData.data = this.tableData.data.concat(JSON.parse(JSON.stringify(this.rowTotal)));
          }


        } else {
          this.form = Object.assign(this.form, {
            invoiceClassify: this.invoiceClassify, // 发票种类
            invoiceCode: "",  //发票代码
            invoiceNumber: "", //发票号码
            billingDate: "",  // 发票日期
            enterprieName: "",  // 供应商、客户
            taxNumber: "",     // 供应商/客户纳税识别号
            remarks: "",  // 备注
            id: "",
            totalAmount: "",
            totalAmountAndTax: "",
            totalTax: "",
            // fullElectricInvoice: true,
          })
          this.tableData.data.push(JSON.parse(JSON.stringify(this.rowData)));
          this.tableData.data = this.tableData.data.concat(JSON.parse(JSON.stringify(this.rowTotal)));
        }
      } else {
        this.tableData.data = []
        document.body.removeEventListener('click', this.handleBodyClick)
      }
    }
  }
}


</script>
<style lang='less' scoped>
@import "./style/newAddPageInvoice.less";
</style>



// WEBPACK FOOTER //
// src/components/dialog/newAddPageInvoice.vue